import { Component, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  FormControl,
} from '@angular/forms';
import { LocaleService } from 'src/app/services/locale.service';
import {
  parseLocaleNumber,
  parseNumberToLocaleCurrency,
} from 'src/app/utils/format-currency';
@Component({
  selector: 'app-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class CurrencyInputComponent implements OnInit {
  currency!: string;
  locale!: string;

  @Input() clearButton = false;
  @Input() label = '';
  @Input() error: string | null = '';
  @Input() placeholder = '';
  @Input() control!: FormControl;

  constructor(private localeService: LocaleService) {
    this.currency = this.localeService.currency;
    this.locale = this.localeService.locale;
  }

  ngOnInit(): void {
    this.handleInputBlur();
  }

  handleInputFocus(): void {
    const value = this.control.value;

    if (value !== null) {
      const parsedNumber = parseLocaleNumber(value, this.locale);
      this.control.patchValue(parsedNumber, {
        emitEvent: false,
      });
    }
  }

  handleInputBlur(): void {
    const value = this.control.value;
    if (value !== null) {
      const parsedValue = parseNumberToLocaleCurrency(
        value,
        this.locale,
        this.currency
      );
      this.control.patchValue(parsedValue);
    }
    if (value === '') {
      this.control.patchValue(null);
    }
  }

  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      charCode > 31 &&
      (charCode < 48 || (charCode > 57 && charCode < 96) || charCode > 105)
    ) {
      return false;
    }
    return true;
  }

  get currencyIcon(): string {
    if (this.currency === 'SEK') return 'sek';
    return 'euro';
  }
}
